import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Nav, NavItem, NavLink, TabContent, TabPane} from 'reactstrap';
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { app } from "../../config";

//redux
import { useSelector, useDispatch } from "react-redux";

import { withRouter, Link } from "react-router-dom";

// Formik validation
import * as Yup from "yup";
import { Formik } from "formik";

// actions
import { loginUser, resetLoginFlag } from "../../store/actions";

//import images
import logoFen from "../../assets/images/logo-fen-blanco.png";
import logoDCSLight from "../../assets/images/logo-dcs-solo-blanco.png";
import logoDCSDark from "../../assets/images/logo-dcs-solo-dark.png";
// import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import classnames from "classnames";

const Login = (props) => {
    const dispatch = useDispatch();
    const { user } = useSelector(state => ({
        user: state.Account.user,
    }));
    const [activeTab, setActiveTab] = useState("1");

    const { sitio } = useParams();

    const [userLogin, setUserLogin] = useState([]);

    const layout = localStorage.getItem("intranet-dcs-settings") ? JSON.parse(localStorage.getItem("intranet-dcs-settings")) : null;
    const layoutMode = layout ? layout.find(x => x.attribute === "data-layout-mode")["value"] : null;

    useEffect(() => {
        if (user && user) {
            setUserLogin({
                username: user.user.username,
                password: user.user.confirm_password
            });
        }
    }, [user]);

    const initialValues = {
        username: '',
        password: '',
    };
    const validationSchema = Yup.object({
        username: Yup.string().required(app.site === "Externo" ? "Ingrese su nombre de usuario" : "Ingrese su nombre de usuario FEN"),
        password: Yup.string().required("Por favor ingrese su contraseña"),
    });

    const { error } = useSelector(state => ({
        error: state.Login.error,
    }));

    useEffect(() => {
        setTimeout(() => {
            dispatch(resetLoginFlag());
        }, 3000);
    }, [dispatch, error]);

    const toggleTab = (tab) => {
        if (activeTab !== tab) {
          setActiveTab(tab);
        }
      };    

      const [topBorderTab, settopBorderTab] = useState("1");
      const topBordertoggle = (tab) => {
          if (topBorderTab !== tab) {
              settopBorderTab(tab);
          }
      };

     console.log("activeTab", activeTab) 
    document.title = app.site === "Intranet" ? "Inicio Sesión | Fénix" : "Portal Uejecutivos";
    return (
        <>
            {app.site === "Externo" && app.ambiente === "produccion" ?
                <div className='d-flex justify-content-center align-items-center flex-column'
                    style={{ height: '100vh', backgroundColor: '#f1f1f1' }}>
                    <h1 className='display-4 fw-bold mb-5'>Página en construcción</h1>
                    <img src="https://uejecutivos.cl/images/home/logo_uejecutivos.png" alt="Logo"></img>
                </div>
                :
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {


                        if(app.site === "Intranet"){
                            dispatch(loginUser(values, props.history));
                        }
                        if(app.site === "Externo"){

                            let tipo = ""
                            switch(activeTab){
                                case "1":
                                    tipo = "aulaVirtual"
                                break;    
                                case "2":
                                    tipo = "uonline"
                                break;
                                case "3":
                                    tipo = "academico"
                                break;  
                            }

                            values = {
                                ...values,
                                type: tipo
                              };       
                              
                            dispatch(loginUser(values, props.history));
                        }                        
                        
                    }}
                >
                    {(formik) => {
                        return (
                            <React.Fragment>
                                <ParticlesAuth>
                                    <div className="auth-page-content">
                                        <Container>
                                            <Row>
                                                <Col lg={12}>
                                                    <div className="text-center mb-4 text-white-50">
                                                        {app.site === "Externo" && app.ambiente === "testing" && <div className='text-warning'>Recordar quitar "página en construcción" cuando se quiera pasar a producción!!</div>}
                                                        <div>
                                                            <Link to="/" className="d-inline-block auth-logo">
                                                                <img src={logoFen} alt="" height="160" />
                                                            </Link>
                                                        </div>
                                                        {sitio === "ssi" ? <p className="mt-3 fs-15 fw-medium">Sistema de la Dirección de Investigación</p>
                                                            : <p className="mt-3 fs-15 fw-medium">Fénix</p>}
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row className="justify-content-center">
                                                <Col md={8} lg={6} xl={5}>
                                                    <Card className="mt-4">
                                                        <CardBody className="p-4">
                                                            <div className="text-center mt-2">
                                                                <h5 className="text-primary">Bienvenid@ !</h5>
                                                                <p className="text-muted">{app.site === "Externo" ? "Escoja tipo de ingreso" : "Inicie sesión para ingresar al sistema" }</p>
                                                            </div>

                                                            {/* **** TABS PARA PORTAL EXTERNO */ }
                                                            {app.site === "Externo" ?    
                                                            <>    
                                                                <Nav tabs className="nav nav-tabs nav-justified nav-border-top nav-border-top-success mb-3">
                                                                    <NavItem>
                                                                        <NavLink style={{ cursor: "pointer" }} className={classnames({ active: topBorderTab === "1", })} onClick={() => { topBordertoggle("1"); toggleTab("1");}} >
                                                                            <i className="ri-bank-line align-middle me-1"></i> Aula Virtual
                                                                        </NavLink>
                                                                    </NavItem>
                                                                    <NavItem>
                                                                        <NavLink style={{ cursor: "pointer" }} className={classnames({ active: topBorderTab === "2", })} onClick={() => { topBordertoggle("2"); toggleTab("2");}} >
                                                                            <i className="ri-reserved-line me-1 align-middle"></i> UONLINE
                                                                        </NavLink>
                                                                    </NavItem>
                                                                    <NavItem>
                                                                        <NavLink style={{ cursor: "pointer" }} className={classnames({ active: topBorderTab === "3", })} onClick={() => { topBordertoggle("3"); toggleTab("3");}} >
                                                                            <i className="ri-book-line align-middle me-1"></i>Académicos
                                                                        </NavLink>
                                                                    </NavItem>
                                                                </Nav>

                                                                <TabContent activeTab={topBorderTab} className="text-muted">
                                                                    <TabPane tabId="1" id="nav-border-justified-home" className="text-center" style={{ backgroundColor: "#006599", color: "#ffffff", padding: "10px" }}>
                                                                    <h6 style={{ color: "#ffffff" }}>Plataforma LMS e-ducativa :: Universidad de Chile</h6>
                                                                    </TabPane>
                                                                    <TabPane tabId="2" id="nav-border-justified-profile" className="text-center" style={{ backgroundColor: "#1C396A", color: "#ffffff", padding: "10px"}}>
                                                                    <h6 style={{ color: "#ffffff" }}>UEjecutivos - Campus Virtual</h6>
                                                                    </TabPane>
                                                                    <TabPane tabId="3" id="nav-border-justified-messages" className="text-center" style={{ backgroundColor: "#1B3F7F", color: "#ffffff", padding: "10px"}}>
                                                                    <h6 style={{ color: "#ffffff" }}>UEjecutivos - Portal Académicos</h6>
                                                                    </TabPane>
                                                                </TabContent>

                                                            </>
                                                            :""}

                                                            {error && error ? (<Alert color="danger"> {error} </Alert>) : null}
                                                            <div className="p-2 mt-4">
                                                                <Form
                                                                    onSubmit={(e) => {
                                                                        e.preventDefault();
                                                                        formik.handleSubmit();
                                                                        return false;
                                                                    }}
                                                                    action="#">

                                                                    <div className="mb-3">
                                                                        <Label htmlFor="username" className="form-label">Usuario</Label>
                                                                        <Input
                                                                            name="username"
                                                                            className="form-control"
                                                                            placeholder={app.site === "Externo" ? "Ingrese su nombre de usuario" : "Ingrese su nombre de usuario FEN"}
                                                                            autoComplete="username"
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            value={formik.values.username || ""}
                                                                            invalid={
                                                                                formik.touched.username && formik.errors.username ? true : false
                                                                            }
                                                                        />
                                                                        {formik.touched.username && formik.errors.username ? (
                                                                            <FormFeedback type="invalid">{formik.errors.username}</FormFeedback>
                                                                        ) : null}
                                                                    </div>

                                                                    <div className="mb-3">
                                                                        <div className="float-end">
                                                                            {app.site === "Externo" && (activeTab !== "1" && activeTab !== "2") ?    
                                                                            <Link to={sitio !== "ssi" ? "/recuperar-password" : "/recuperar-password/ssi"} className="text-muted">Olvidó su contraseña?</Link>
                                                                            :""}
                                                                            {app.site !== "Externo" ?    
                                                                            <Link to={sitio !== "ssi" ? "/recuperar-password" : "/recuperar-password/ssi"} className="text-muted">Olvidó su contraseña?</Link>
                                                                            :""}                                                                            
                                                                        </div>
                                                                        <Label className="form-label" htmlFor="password-input">Contraseña</Label>
                                                                        <div className="position-relative auth-pass-inputgroup mb-3">
                                                                            <Input
                                                                                name="password"
                                                                                value={formik.values.password || ""}
                                                                                type="password"
                                                                                autoComplete="current-password"
                                                                                className="form-control pe-5"
                                                                                placeholder="Ingrese su contraseña"
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={
                                                                                    formik.touched.password && formik.errors.password ? true : false
                                                                                }
                                                                            />
                                                                            {formik.touched.password && formik.errors.password ? (
                                                                                <FormFeedback type="invalid">{formik.errors.password}</FormFeedback>
                                                                            ) : null}

                                                                        </div>
                                                                    </div>
                                                                    {app.site !== "Externo" ?
                                                                    <div className="form-check">
                                                                        <Input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
                                                                        <Label className="form-check-label" htmlFor="auth-remember-check">Recordarme</Label>
                                                                    </div>
                                                                    :""} 

                                                                    <div className="mt-4">
                                                                        <Button color="success" className="btn btn-success w-100" type="submit">Iniciar Sesión</Button>
                                                                    </div>

                                                                </Form>
                                                            </div>

                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                    {sitio !== "ssi" && <div className='d-flex justify-content-center align-items-end'>
                                        <img className='opacity-75' src={layoutMode !== "dark" ? logoDCSDark : logoDCSLight} alt="DCS Logo" height={75} />
                                    </div>}
                                </ParticlesAuth>
                            </React.Fragment>
                        )
                    }}
                </Formik>
            }
        </>
    );
};

export default withRouter(Login);